var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F0EEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2841 16.2756L23.3333 15.4108L20.6731 10.0178C20.6005 9.87013 20.4809 9.75059 20.3333 9.67794C19.963 9.49513 19.513 9.64747 19.3278 10.0178L16.6677 15.4108L10.7169 16.2756C10.5528 16.299 10.4028 16.3764 10.288 16.4936C10.1491 16.6363 10.0726 16.8283 10.0753 17.0273C10.0779 17.2264 10.1595 17.4163 10.302 17.5553L14.6075 21.7529L13.5903 27.6803C13.5665 27.8182 13.5817 27.96 13.6344 28.0896C13.687 28.2193 13.7749 28.3316 13.8881 28.4138C14.0014 28.496 14.1353 28.5449 14.2749 28.5549C14.4145 28.5648 14.5541 28.5355 14.6778 28.4701L20.0005 25.6717L25.3231 28.4701C25.4684 28.5475 25.6372 28.5732 25.7989 28.5451C26.2067 28.4748 26.4809 28.0881 26.4106 27.6803L25.3934 21.7529L29.6989 17.5553C29.8161 17.4404 29.8934 17.2904 29.9169 17.1264C29.9802 16.7162 29.6942 16.3365 29.2841 16.2756Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/collection-icon.27de9def9c9302b38fd5aa6dcd07faee.svg";
export { ForwardRef as ReactComponent };